'use client';

import PRODUCTPAGE from '@/views/product/enrichment';

export default PRODUCTPAGE;
